var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD396B"
    },
    d: "M504.783,195.473C477.587,83.304,376.53,0,256,0C114.615,0,0,114.615,0,256 c0,118.045,79.904,217.411,188.572,247.007L504.783,195.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B3256"
    },
    d: "M512,256c0-20.855-2.512-41.119-7.217-60.527l-77.49-77.49l-59.314,13.715l-96.238-96.238 L256,116.636l-148.431,7.818l-56.616,87.889l-4.483,63.97l132.173,132.173l-42.296,42.296l52.225,52.225 C210.057,508.858,232.661,512,256,512C397.384,512,512,397.384,512,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFEBB4"
    },
    points: "419.662,128 393.411,128 468.388,247.964 478.606,222.609  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFEBB4"
    },
    points: "381.724,128 407.975,128 332.997,247.964 322.779,222.609  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE47"
    },
    d: "M389.562,233.739l89.043,11.13c0,24.487-20.035,44.522-44.522,44.522h-33.391L389.562,233.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE290"
    },
    d: "M400.692,233.739v55.652h-33.391c-24.487,0-44.522-20.035-44.522-44.522L400.692,233.739z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB14E"
    },
    points: "400.692,222.609 393.445,233.739 400.692,244.87 478.606,244.87 478.606,222.609 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.783,
    y: 222.609,
    style: {
      fill: "#FFD86C"
    },
    width: 77.913,
    height: 22.261
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFF5D9"
    },
    points: "130.273,128 104.023,128 179,247.964 189.219,222.609  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFF5D9"
    },
    points: "92.336,128 118.587,128 43.609,247.964 33.391,222.609  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE290"
    },
    points: "222.61,95.721 256.001,84.59 256,140.242 84.708,140.242 84.708,117.982 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD86C"
    },
    points: "289.39,95.721 255.999,84.59 256,140.242 427.292,140.242 427.292,117.982 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9356"
    },
    points: "255.999,73.461 236.432,129.112 289.39,95.722 289.39,73.461 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB14E"
    },
    points: "222.608,73.461 222.608,95.722 255.999,129.113 255.999,73.461  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB14E"
    },
    points: "255.999,95.722 236.432,151.373 289.39,140.242 289.39,95.722  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE47"
    },
    points: "222.608,95.722 222.608,140.242 255.999,151.373 255.999,95.722 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB14E"
    },
    points: "255.999,150.261 236.432,395.129 278.26,395.129 278.26,150.261 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 233.739,
    y: 150.261,
    style: {
      fill: "#FFCE47"
    },
    width: 22.261,
    height: 244.87
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE47"
    },
    points: "255.999,361.739 247.74,395.129 289.39,395.129 289.39,361.739  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 222.609,
    y: 361.739,
    style: {
      fill: "#FFD86C"
    },
    width: 33.39,
    height: 33.391
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9356"
    },
    points: "255.999,384 247.74,417.39 335.581,417.39 335.581,384 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176.417,
    y: 384,
    style: {
      fill: "#FFB14E"
    },
    width: 79.583,
    height: 33.391
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB14E"
    },
    points: "233.741,406.26 233.738,439.651 375.651,428.521 335.581,406.26  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE47"
    },
    points: "255.999,406.26 176.416,406.26 136.347,428.521 255.999,439.651 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9356"
    },
    points: "255.999,428.521 244.868,439.651 255.999,450.781 375.651,450.781 375.651,428.521 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.348,
    y: 428.522,
    style: {
      fill: "#FFB14E"
    },
    width: 119.652,
    height: 22.261
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9356"
    },
    points: "255.999,140.242 251.857,151.373 255.999,162.503 289.39,162.503 289.39,140.242 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.609,
    y: 140.243,
    style: {
      fill: "#FFB14E"
    },
    width: 33.391,
    height: 22.261
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE47"
    },
    d: "M255.999,28.939L244.868,51.2l11.13,22.261c12.295,0,22.261-9.966,22.261-22.261 S268.294,28.939,255.999,28.939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE290"
    },
    d: "M233.738,51.2c0,12.295,9.966,22.261,22.261,22.261V28.939 C243.704,28.939,233.738,38.905,233.738,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD86C"
    },
    d: "M100.174,233.739l89.043,11.13c0,24.487-20.035,44.522-44.522,44.522h-33.391L100.174,233.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEBB4"
    },
    d: "M111.304,233.739v55.652H77.913c-24.487,0-44.522-20.035-44.522-44.522L111.304,233.739z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE47"
    },
    points: "111.304,222.609 104.057,233.739 111.304,244.87 189.219,244.87 189.219,222.609 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.391,
    y: 222.609,
    style: {
      fill: "#FFD86C"
    },
    width: 77.913,
    height: 22.261
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.174,
    y: 307.757,
    style: {
      fill: "#FF755C"
    },
    width: 22.261,
    height: 22.261
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.696,
    y: 307.757,
    style: {
      fill: "#FF755C"
    },
    width: 22.261,
    height: 22.261
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.652,
    y: 307.757,
    style: {
      fill: "#FF755C"
    },
    width: 22.261,
    height: 22.261
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 389.565,
    y: 307.757,
    style: {
      fill: "#4EB9FF"
    },
    width: 22.261,
    height: 22.261
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.043,
    y: 307.757,
    style: {
      fill: "#4EB9FF"
    },
    width: 22.261,
    height: 22.261
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.087,
    y: 307.757,
    style: {
      fill: "#4EB9FF"
    },
    width: 22.261,
    height: 22.261
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.af3c162976aa62026a3960943a7ad27e.svg";
export { ForwardRef as ReactComponent };